export default {"src":"/_next/static/media/1.c5dcb2c5.gif","height":720,"width":1280};